import React, { useEffect } from "react";
import { useForm, validators } from "@hooks";
import classNames from "classnames";
import { sunboundPayProxy } from '@proxies';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSpinnerContext } from '@contexts';
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { helpers } from "@shared";

const ResendWelcome = () => {

    const initialState = { email: `` };
    const location = useLocation(), navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validations = {
        email: (val) => validators.isValidEmail(val) || { email: `Email is not valid` },
    };

    const handleSubmit = async (values) => {
        setSpinnerShow(true);
        try {
            const { email } = values;
            await sunboundPayProxy.resendWelcome(email);
            helpers.navigateNext(location, navigate, undefined, { email });

        } catch (error) {
            console.error(error);
        } finally {
            setSpinnerShow(false);
        }
    };

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, handleSubmit);

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Something went wrong</h1>
            <span className="page-subheader">Whoops! It looks like something went wrong. Type your email below and we&apos;ll send a new link.</span>

            <div className="content-box shadow-sb items-start">
                <form method="POST" className="w-full flex flex-col gap-y-4" onSubmit={submitHandler} >
                    <div className="w-full">
                        <div className="flex flex-col">
                            <label htmlFor="email" className="font-semibold text-gray-700">Email</label>
                            <span className="text-gray-500 text-sm">Be sure to use the same email address where we sent the first signup link</span>
                        </div>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input type="text" name="email" id="email" className={classNames(
                                `block w-full rounded-md shadow-md focus:outline-none border-gray-300 text-gray-600 disabled:bg-gray-200`,
                                { "input-error": errors.email }
                            )} value={values.email} onChange={changeHandler} aria-invalid="true" aria-describedby="email-error" />
                            {
                                errors.email &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-6" />
                                </div>
                            }
                        </div>
                        {
                            errors.email &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.email}</p>
                        }
                    </div>
                    <button type="submit" className="btn btn-primary font-bold rounded-full my-4">Continue</button>
                </form>
            </div>
        </div>
    );
};

export default ResendWelcome;